
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/components/auth/AuthProvider";
import { toast } from "sonner";
import { processWaitlistSubmission, processNursingHomeLeads } from "@/utils/waitlist-processor";

export function useThankYouPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const nursingHomeName = searchParams.get('nursing_home') || undefined;
  const countyName = searchParams.get('county') || undefined;
  const nursingHomeSlug = searchParams.get('nh_slug') || undefined;
  const fromWaitlist = searchParams.get('from') === 'waitlist';
  const isUnauthenticated = searchParams.get('auth') === 'needed';
  const { user } = useAuth();

  useEffect(() => {
    const justLoggedIn = sessionStorage.getItem('justCompletedAuth');
    if (justLoggedIn && user) {
      sessionStorage.removeItem('justCompletedAuth');
      toast.success(`Welcome ${user.user_metadata?.first_name || 'back'}!`, {
        description: "Please complete your waitlist registration.",
        duration: 5000
      });
      
      // Process submission with saved data if available
      const formData = sessionStorage.getItem('waitlistFormData');
      if (formData && user) {
        const processStoredData = async () => {
          try {
            const parsedData = JSON.parse(formData);
            await processWaitlistSubmission(user.id, parsedData);
            
            // Process nursing home leads
            if (nursingHomeName || nursingHomeSlug || parsedData.preferredLocation?.length > 0) {
              await processNursingHomeLeads(
                user.id,
                parsedData,
                nursingHomeName,
                nursingHomeSlug,
                countyName
              );
            }
            
            // Clear stored data and redirect
            sessionStorage.removeItem('waitlistFormData');
            toast.success("Your waitlist registration has been completed", {
              description: "View your dashboard to see your saved nursing homes."
            });
            
            setTimeout(() => navigate('/dashboard'), 1500);
          } catch (e) {
            console.error("Error processing waitlist data:", e);
            toast.error("Could not process all your waitlist data", {
              description: "Please check your dashboard and try again if needed."
            });
          }
        };
        
        processStoredData();
      }
    }
  }, [user, navigate, nursingHomeName, nursingHomeSlug, countyName]);

  return {
    fromWaitlist,
    isUnauthenticated,
    user
  };
}
